export default {
  // AquaMail Avatar Variants
  
  // User profile variants
  profile_small: "w-8 h-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0",
  profile_medium: "w-12 h-12 bg-primary rounded-full flex items-center justify-center flex-shrink-0",
  profile_large: "w-16 h-16 bg-primary rounded-full flex items-center justify-center flex-shrink-0",
  profile_xl: "w-20 h-20 bg-primary rounded-full flex items-center justify-center flex-shrink-0",
  
  // Navigation variants
  nav_small: "w-8 h-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0",
  nav_medium: "w-10 h-10 bg-primary rounded-full flex items-center justify-center flex-shrink-0",
  
  // Chat/message variants
  chat_small: "w-8 h-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0",
  chat_medium: "w-10 h-10 bg-primary rounded-full flex items-center justify-center flex-shrink-0",
  chat_large: "w-12 h-12 bg-primary rounded-full flex items-center justify-center flex-shrink-0",
  
  // Team member variants
  team_small: "w-10 h-10 bg-gradient-to-r from-primary to-primary_hov rounded-full flex items-center justify-center flex-shrink-0",
  team_medium: "w-12 h-12 bg-gradient-to-r from-primary to-primary_hov rounded-full flex items-center justify-center flex-shrink-0",
  team_large: "w-16 h-16 bg-gradient-to-r from-primary to-primary_hov rounded-full flex items-center justify-center flex-shrink-0",
  
  // Status variants
  online: "w-10 h-10 bg-success rounded-full flex items-center justify-center flex-shrink-0 border-2 border-success_light",
  offline: "w-10 h-10 bg-text_secondary rounded-full flex items-center justify-center flex-shrink-0 border-2 border-neutral_1",
  away: "w-10 h-10 bg-warning rounded-full flex items-center justify-center flex-shrink-0 border-2 border-warning_light",
  busy: "w-10 h-10 bg-error rounded-full flex items-center justify-center flex-shrink-0 border-2 border-error_light",
  
  // Bordered variants
  bordered_light: "w-10 h-10 bg-primary border-2 border-neutral_1 rounded-full flex items-center justify-center flex-shrink-0",
  bordered_white: "w-10 h-10 bg-primary border-2 border-white rounded-full flex items-center justify-center flex-shrink-0",
  bordered_primary: "w-10 h-10 bg-primary border-2 border-primary_hov rounded-full flex items-center justify-center flex-shrink-0",
  
  // Contact list variants
  contact_list: "w-10 h-10 bg-primary rounded-full flex items-center justify-center flex-shrink-0",
  contact_list_small: "w-8 h-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0",
  
  // Email signature variants
  signature_small: "w-6 h-6 bg-primary rounded-full flex items-center justify-center flex-shrink-0",
  signature_medium: "w-8 h-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0",
}